import state from "./moduleRolesState.js";
import mutations from "./moduleRolesMutation.js";
import actions from "./moduleRolesActions.js";
import getters from "./moduleRolesGetters.js";

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
